import { dataMagnetSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMagnetSolid = /*#__PURE__*/createIcon(dataMagnetSolid)
export default IconMagnetSolid
